// This import has been flagged as unallowed for this class. It may be involved in a circular dependency loop.
// eslint-disable-next-line no-restricted-imports
import { KdfType } from "@bitwarden/key-management";

import { BaseResponse } from "../../../models/response/base.response";

export class PreloginResponse extends BaseResponse {
  kdf: KdfType;
  kdfIterations: number;
  kdfMemory?: number;
  kdfParallelism?: number;
  // Fyin pepper-strengthened PIN (see docs/security/Design.md in the
  // Vaultwarden wrapper). For migrated users, the server emits these so
  // the client knows to derive the master key from `pin || pepper`
  // instead of `pin`. Absent for unmigrated users — the legacy path runs.
  pepperRequired?: boolean;
  pepper?: string;
  pepperKekVersion?: number;

  constructor(response: any) {
    super(response);
    this.kdf = this.getResponseProperty("Kdf");
    this.kdfIterations = this.getResponseProperty("KdfIterations");
    this.kdfMemory = this.getResponseProperty("KdfMemory");
    this.kdfParallelism = this.getResponseProperty("KdfParallelism");
    this.pepperRequired = this.getResponseProperty("PepperRequired");
    this.pepper = this.getResponseProperty("Pepper");
    this.pepperKekVersion = this.getResponseProperty("PepperKekVersion");
  }
}
